<template>
  <div>
    <b-card no-header>
      <form>
        <b-form-group>
          <b-form-textarea
            id="descripcion"
            v-model="$v.descripcion.$model" 
            rows="5"
            max-rows="5"
            :state="descripcionValida"
            @blur.native="validate">
          </b-form-textarea>
        </b-form-group>

        <b-form-group>
          <b-form-textarea
            id="descripcionGpt"
            :value="descripcionGpt" 
            rows="5"
            max-rows="5"
            readonly>
          </b-form-textarea>
        </b-form-group>
      </form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button" 
          @click.prevent="askGpt">Completar</b-button>
        <b-button size="sm" variant="primary" class="footer-button" 
          :disabled="descripcionGpt === ''"
          @click.prevent="update">Actualizar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="close">Cerrar</b-button>

        <b-button size="sm" variant="primary" class="footer-button" 
          @click.prevent="startRecording" :disabled="isRecording">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="stopRecording" :disabled="!isRecording">Detener</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelRecording" :disabled="!isRecording">Cancelar</b-button>
      </div>
    </b-card>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue'
import { msjModal } from '../../mixins/modalDialogs'
import { audioRecorder } from '../../mixins/audio_recorder'
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'gptModal',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [
    msjModal,
    audioRecorder
  ],
  props: {
    current: {
      type: String,
      default: '',
    },
    rubroTrabajoId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      descripcionValida: null,
      descripcionInvalidaMsj: '',

      labelCols: 2,
      descripcion: '',
      descripcionGpt: '',
    }
  },
  created() {
    this.descripcion = this.current;
  },  
  methods: {
    askGpt() {
      let askGpt = true;

      this.$v.$touch();

      if (this.$v.descripcion.$error) {
        this.descripcionValida = false;
        askGpt = false;
        if (!this.$v.descripcion.required) {
          this.descripcionInvalidaMsj = 'Debe ingresar la descripción a completar';
        } else if (!this.$v.descripcion.maxLength) {
          this.descripcionInvalidaMsj = 'La descripción sólo puede contener hasta 5000 caracteres';
        }
      } else {
        this.descripcionValida = null;
        this.descripcionInvalidaMsj = '';
      }

      if (askGpt) {
        this.showSpinner();
        this.$store.dispatch('ordentrabajo/askGpt', this.rubroTrabajoId)
          .then(() => {
            this.descripcionGpt = this.$store.getters['ordentrabajo/descripcionGpt'];
          })
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    update() {
      let params = {
        updated: true,
        descripcion: this.descripcionGpt,
      }
      this.$emit('close', params);
    },
    close() {
      let params = {
        updated: false
      }
      this.$emit('close', params);
    },
    onAudioReady(blob) {
      this.showSpinner();
      this.$store.dispatch('ordentrabajo/askTranscription', blob)
        .then(() => {
          this.descripcionGpt = this.$store.getters['ordentrabajo/descripcionGpt'];
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
  },
  validations: {
    descripcion: {
      required,
      maxLength: maxLength(5000)
    },
  },  
}
</script>

<style>
</style>
